export var HEADER_HEIGHT = {
  MOBILE: '66px',
  TABLET: '72px',
  TABLET_HORIZONTAL: '77px',
  DESKTOP: '77px'
};